import { Component, Input, OnInit } from '@angular/core';
import { DateTime } from 'luxon';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '../../import/services/translation.service';
import { baseHOST } from '../../routes';
import { CharacteristicSpecificationComponent } from '../characteristic-specification/characteristic-specification.component';
import { DataAdministrationService } from '../../data-administration/services/data-administration-service';
import { ImportService } from '../../import/services/import.service';
import { ImportEntity } from '../../import/entities/ImportEntity';

@Component({
  selector: 'app-create-entity',
  templateUrl: './create-entity.component.html',
  styleUrls: ['./create-entity.component.scss']
})
export class CreateEntityComponent implements OnInit {

	@Input() hostEntity: Object;
	@Input() hostFormField: Object;
	@Input() entity: Object = {};
	@Input() entityType: string;
	@Input() importEntity: ImportEntity = new ImportEntity();
	@Input() content: Object = {};
	@Input() referencedCandidates: Object = {};
	formEntity = new FormGroup({});
	entityType_single_translated: string;
	fullEntityType: string;
	candidates = [];
	loading: boolean = true;
	showOptionalFields: boolean = true;
	formModel: Object = {};
	buttonLocked: boolean = false;
	showPassword: boolean = false;

	public tools: object = {
        items: ['Undo', 'Redo', '|',
            'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
            'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
            'SubScript', 'SuperScript', '|',
            'LowerCase', 'UpperCase', '|',
            'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
            'Indent', 'Outdent', '|', 'CreateLink',
            'Image', '|', 'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen']
    };
    public quickTools: object = {
        image: [
            'Replace', 'Align', 'Caption', 'Remove', 'InsertLink', '-', 'Display', 'AltText', 'Dimension']
    };

	constructor(private dataAdministrationService: DataAdministrationService, private importService: ImportService, public activeModal: NgbActiveModal, private modalService: NgbModal, private toastManager: ToastrService, private translate: TranslateService, private translationService: TranslationService) { }

	ngOnInit() {
		if (this.entity === undefined) this.entity = {};
		this.fullEntityType = this.entityType;
		this.entityType = this.translationService.convertEntityType(this.entityType);
		this.translate.get('data_administration.entities.' + this.entityType + ".single").subscribe((res: string) => { this.entityType_single_translated = res; });
		this.dataAdministrationService.getForm(this.entityType, 'POST', null).subscribe(formFields => {
			this.formModel['form_fields'] = formFields;
			var self = this;
			this.formModel['form_fields'].forEach(function (formField) {
				formField['upload_download'] = 'upload';
				
				// get tooltip
				var tooltipTranslationKey = 'data_administration.entities.' + self.entityType + '.tooltips.' + formField['snake_case'];
				self.translate.get(tooltipTranslationKey).subscribe((res: string) => {
						if (res !== tooltipTranslationKey) formField['tooltip'] = res;
					});

				if (formField.data_type == 'select') {
					if (self.candidates[formField.target_entity] === undefined && formField.target_entity !== 'App\\Entity\\CharacteristicSpecification') {
						self.dataAdministrationService.loadAllCandidates(formField.target_entity, formField.internal_field_name).subscribe(
							response => {
								var filteredResponse = response.filter(candidate => candidate.name !== undefined);
								formField['candidates'] = [];
								filteredResponse.forEach(function (candidate) {
									formField['candidates'].push({value: candidate.id, label: candidate.name});
								});
								self.candidates[formField.target_entity] = formField['candidates'];
							});
					} else {
						formField['candidates'] = self.candidates[formField.target_entity];
					}	
				} else if ((self.entity[formField['snake_case']] == undefined || self.entity[formField['snake_case']] == null) && formField['default_value'] !== undefined) {
					self.entity[formField['snake_case']] = formField['default_value'];
				}

				var validators = [];
				if (formField['not_null'] === true) validators.push(Validators.required);
				if (formField['email'] === true) validators.push(Validators.email);
				var formControl = new FormControl();
				formControl.setValidators(validators);
				self.formEntity.addControl(formField['snake_case'], formControl);
			});

			Object.keys(this.entity).forEach(function (key) {
				var value = self.entity[key];
				var formField = self.formModel['form_fields'].filter(formField => formField['snake_case'] === key)[0];
				var associatedFormFields = self.formModel['form_fields'].filter(formField => formField['snake_case'].includes(key + ' - '));

				if (associatedFormFields.length === 0) {
					if (!self.formEntity.get(key)) self.formEntity.addControl(key, new FormControl());
					if (typeof value === 'object' && value !== null) {
						if (Array.isArray(value)) {
							var arrayValue = [];
							value.forEach(function(elem) {
								if (typeof elem === 'object' && elem != null && key !== 'characteristic_specifications') {
									if (elem['id'] !== undefined) {
										arrayValue.push(elem['id']);
									}
								} else {
									if (key === 'characteristic_specifications') arrayValue.push({'value': elem['id'], 'display': elem['characteristic']['name']});
									else arrayValue.push(elem);
								}
							});

							self.formEntity.get(key).patchValue(arrayValue);
						} else if (value['id'] !== undefined) {
							self.formEntity.get(key).patchValue(value['id']);
						}
					} else {
						self.formEntity.get(key).patchValue(value);
					}

					if (formField) {
						if (formField['file'] !== undefined) {
							formField['path'] = self.getAbsolutePath(value);
						} else if (value !== null && value !== undefined && (formField['data_type'] == 'date' || formField['data_type'] == 'datetime')) {
							value = DateTime.fromISO(value).toISODate();
							self.formEntity.get(key).patchValue(value);
						}
					}
				} else if (typeof value === 'object' && value !== null) {
					Object.keys(value).forEach(function (referencedKey) {
						var referencedValue = value[referencedKey];
						var fullKey = key + ' - ' + referencedKey;
						if (!self.formEntity.get(fullKey)) self.formEntity.addControl(fullKey, new FormControl());
						if (typeof referencedValue === 'object' && referencedValue !== null) {
							if (Array.isArray(referencedValue)) {
								var arrayValue = [];
								referencedValue.forEach(function(elem) {
									if (typeof elem === 'object' && elem != null && referencedKey !== 'characteristic_specifications') {
										if (elem['id'] !== undefined) arrayValue.push(elem['id']);
									} else {
											if (fullKey === 'characteristic_specifications') arrayValue.push({'value': elem['id'], 'display': elem['characteristic']['name']});
											else arrayValue.push(elem);
									}
								});

								self.formEntity.get(fullKey).patchValue(arrayValue);
							} else if (referencedValue['id'] !== undefined) {
								self.formEntity.get(fullKey).patchValue(referencedValue['id']);
							}
						} else {
							self.formEntity.get(fullKey).patchValue(referencedValue);
						}
					});
				}	
			});

			this.loading = false;
		}, err => {
			this.translate.get('data_administration.errors.load_form').subscribe((res: string) => {
				this.toastManager.error(res);
				this.loading = false;
				this.activeModal.close();
			});
		});
	}

	saveEntity() {
		console.log(this.formEntity.value);
		var self = this;
		this.buttonLocked = true;
		this.dataAdministrationService.createEntity(null, this.entityType, this.formEntity.value, this.formModel['form_fields']).subscribe(
			response => {
				const results = this.formModel['form_fields'].filter(formField => formField['file'] == true && formField['upload_download'] == 'upload');
				results.forEach(function (formField) {
				self.dataAdministrationService.handleFile(null, self.entityType, response['id'], formField['snake_case'], formField['internal_field_name'], self.formEntity.get(formField['snake_case']).value).subscribe(
						response => {
							console.log(response);
						}, err => {
							self.translate.get('data_administration.errors.file_upload').subscribe((res: string) => { self.toastManager.error(res); });
					});
				});

				if (this.hostEntity && this.hostFormField) {
					if (this.hostFormField['multiple'] && this.hostFormField['multiple'] === true) {
						if (!this.hostEntity[this.hostFormField['snake_case']]) {
							this.hostEntity[this.hostFormField['snake_case']] = [];
						}
						this.hostEntity[this.hostFormField['snake_case']].push(response['id']);
					} else {
						this.hostEntity[this.hostFormField['snake_case']] = response['id'];
					}

					this.dataAdministrationService.loadAllCandidates(this.hostFormField['target_entity'], this.hostFormField['internal_field_name']).subscribe(
						response => {
							var filteredResponse = response.filter(candidate => candidate.name !== undefined);
							this.hostFormField['candidates'] = [];
							filteredResponse.forEach(function (candidate) {
								self.hostFormField['candidates'].push({value: candidate.id, label: candidate.name});
							});
						});
				}

				if (this.importEntity['id']) {
					this.importEntity['database_entity'] = response['id'];
					self.importService.updateImportEntity(this.importEntity).subscribe(entity => {
						if (!this.content['importEntities']) {
							self.importService.loadAllCandidates(this.entityType, null).subscribe(candidatesResponse => {
								this.referencedCandidates[this.fullEntityType] = [];
								var filteredResponse = candidatesResponse.filter(candidate => candidate.name !== undefined);
								filteredResponse.forEach(function(candidate) {
									self.referencedCandidates[self.fullEntityType].push({value: candidate['id'], label: candidate['name']});
								});
								this.translate.get('data_administration.success.create',  {entityType: this.entityType_single_translated})
								.subscribe((res: string) => {
									this.toastManager.success(res);
									this.activeModal.close();
								});
							}, err => {
								this.referencedCandidates[this.fullEntityType] = [];
								this.referencedCandidates[this.fullEntityType].push({value: response['id'], label: ''});
								this.translate.get('data_administration.success.create',  {entityType: this.entityType_single_translated})
								.subscribe((res: string) => {
									this.toastManager.success(res);
									this.activeModal.close();
								});
							});
						} else {
							this.translate.get('data_administration.success.create',  {entityType: this.entityType_single_translated})
								.subscribe((res: string) => {
									this.toastManager.success(res);
									this.activeModal.close();
								});
							var index = this.content['importEntities'].indexOf(this.importEntity);
							var filterIndex = this.content['filteredImportEntities'].indexOf(this.importEntity);
							this.content['importEntities'].splice(index, 1);
							this.content['filteredImportEntities'].splice(filterIndex, 1);
						}
					}, err => {
						this.translate.get('import.errors.import_entity_update').subscribe((res: string) => {
							this.toastManager.error(res);
							this.activeModal.close();
						});
					})
				} else {
					this.activeModal.close();
				}
			}, err => {
				this.buttonLocked = false;
				this.translate.get('data_administration.errors.create',  {entityType: this.entityType_single_translated})
				.subscribe((res: string) => { this.toastManager.error(res); });  
			}
		);
	}

	cancel() {
		this.activeModal.close();
	}

	onFileChange(event, formField) {
		if (event.target.files && event.target.files.length) {
			const [file] = event.target.files;

			if (formField['max_size'] === undefined || file.size <= formField['max_size']) {
				this.formEntity.get(formField['snake_case']).patchValue(file);
				this.preview(event.target.files, formField);
			} else {
				event.target.value = '';
				this.translate.get('data_administration.errors.file_too_large').subscribe((res: string) => {
					this.toastManager.error(res);
				});
			}
		}
	}

	preview(files, formField) {
		if (files.length === 0)
		  return;
	 
		if (files[0].type.startsWith('image')) {
			var reader = new FileReader();
			reader.readAsDataURL(files[0]); 
			reader.onload = (_event) => { 
			formField['path'] = reader.result; 
			}
		} else {
			return;
		}
	}

	getAbsolutePath(path) {
		if (path !== undefined && path !== null) {

			var r = new RegExp('^(?:[a-z]+:)?//', 'i');

			if (r.test(path)) { // absolute path
				return path;
			} else {
				return baseHOST + path;
			}
		};

		return null;
	}

	removeFile(event, formField) {
		document.getElementById(formField['snake_case'])['value'] = '';
		this.formEntity.get(formField['snake_case']).patchValue(null);
		formField['path'] = null;
	}

	createForeignEntity(formField) {
		if (formField['target_entity'] === 'App\\Entity\\CharacteristicSpecification') {
			const modalRef = this.modalService.open(CharacteristicSpecificationComponent, {size: 'lg'});
			modalRef.componentInstance.mode = 'create';
			var entityType = this.entityType;
			if (formField['host_entity_type']) entityType = formField['host_entity_type'];
			modalRef.componentInstance.fieldName = formField['snake_case'];
			modalRef.componentInstance.entityType = entityType;
			modalRef.componentInstance.fieldName = formField['snake_case'];
			modalRef.componentInstance.hostEntity = this.formEntity.value;
			modalRef.componentInstance.formField = formField;
		} else {
			this.importService.getDetailedImportEntity(this.importEntity, formField['internal_field_name'], this.entityType).subscribe(entity => {
				const modalRef = this.modalService.open(CreateEntityComponent, {size: 'lg'});
				modalRef.componentInstance.hostEntity = this.formEntity.value;
				modalRef.componentInstance.hostFormField = formField;
				modalRef.componentInstance.entityType = formField['target_entity'];
				modalRef.componentInstance.entity = entity;
			}, err => {
				const modalRef = this.modalService.open(CreateEntityComponent, {size: 'lg'});
				modalRef.componentInstance.hostEntity = this.formEntity.value;
				modalRef.componentInstance.hostFormField = formField;
				modalRef.componentInstance.entityType = formField['target_entity'];
				modalRef.componentInstance.importEntity = this.importEntity;
			});
		}
	}

	onSelectCharacteristicSpecification(obj, formField) {
		var id = obj['value'];
		const modalRef = this.modalService.open(CharacteristicSpecificationComponent, {size: 'lg'});
		modalRef.componentInstance.mode = 'edit';
		var entityType = this.entityType;
		if (formField['host_entity_type']) entityType = formField['host_entity_type'];
		modalRef.componentInstance.entityType = entityType;
		modalRef.componentInstance.fieldName = formField['snake_case'];
		modalRef.componentInstance.fieldName = formField['snake_case'];
		modalRef.componentInstance.hostEntity = this.formEntity.value;
		modalRef.componentInstance.characteristicSpecificationId = id;
	}

	showOrHidePassword() {
		this.showPassword = !this.showPassword;
	}

	generatePassword(formField) {
		var result = '';
		var characters = 'abcdefghijklmnopqrstuvwxyz';
		var specialCharacters = '!-/+*_?ß';
		var digits = '0123456789';

		var length = Math.floor(Math.random() * 5 + 12);
		var result = digits.charAt(Math.floor(Math.random() * digits.length)) + specialCharacters.charAt(Math.floor(Math.random() * specialCharacters.length)) + characters.charAt(Math.floor(Math.random() * characters.length)).toUpperCase() + characters.charAt(Math.floor(Math.random() * characters.length));

		for (var i = 4; i < length; i++) {
			var character = '';
			var random = Math.random();
			
			if (random <= 0.25) {
				character = digits.charAt(Math.floor(Math.random() * digits.length));
			} else if (random <= 0.85) {
				character = characters.charAt(Math.floor(Math.random() * characters.length));
				if (random > 0.6) character = character.toUpperCase();
			} else {
				character = specialCharacters.charAt(Math.floor(Math.random() * specialCharacters.length))
			}

			result += character;
		}

		this.entity[formField['snake_case']] = result;
		this.showPassword = true;
	}

	getReferencedFieldString(formField) {
		var hostEntityTypeParts = formField['host_entity_type'].split('\\');
		var hostEntityType = hostEntityTypeParts[hostEntityTypeParts.length - 1];
		var fieldNameParts = formField['snake_case'].split(' - ');
		var fieldName = fieldNameParts[fieldNameParts.length - 1];
		var result = 'data_administration.entities.' + hostEntityType.charAt(0).toLowerCase() + hostEntityType.slice(1) + '.properties.' + fieldName;
		return result;
	}
}
